var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth"},[(!_vm.user)?_c('Sign-In'):_c('Sign-Out')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }